import { render, staticRenderFns } from "./PTSelect.vue?vue&type=template&id=718501a1&lang=pug&"
import script from "./PTSelect.vue?vue&type=script&lang=js&"
export * from "./PTSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports